<template>
  <div v-if="entries.length > 0" class="alert alert-info py-2 px-3 mb-3">
    <div class="fw-semibold text-capitalize-first mb-1">
      {{ helper.trans('labels.payin_balance_available_for_payout') }}
    </div>
    <ul class="list-unstyled mb-0 small">
      <li v-for="entry in entries" :key="entry.currency">
        <strong>{{ entry.currency }}:</strong> {{ entry.formattedAmount }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType} from 'vue'
import TraderPayoutLimitDTO from "@/models/TraderPayoutLimitDTO";
import {helper} from "@/service/CommonHelper";
import {payoutLimitEntries} from "@/service/PayoutLimitHelper";

export default defineComponent({
  props: {
    limit: {
      type: Object as PropType<TraderPayoutLimitDTO>,
      required: true,
    },
  },
  setup(props) {
    const entries = computed(() => payoutLimitEntries(props.limit.availableByCurrency));

    return {
      helper,
      entries,
    };
  },
})
</script>
